import React, { Component } from 'react';

import MixedHealthServersComponent from './MixedHealthServersComponent'
import { actions } from './MixedHealthServersReducer'
import { connect } from 'react-redux'

class Wrapper extends Component {
    componentDidMount() {
        this.props.fetch();
    }
    render() {
        return (
            <React.Fragment>
                <MixedHealthServersComponent {...this.props} />                
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        fetcher: state.waas.mixedHealthServers.fetcher,
        isLoading: state.waas.mixedHealthServers.mixedHealthServers.isLoading || state.waas.mixedHealthServers.fetcher.loading,
        items: state.waas.mixedHealthServers.fetcher.items || []
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetch: () => {
            dispatch(actions.trigger())
        },
        reload: () => {
            dispatch(actions.trigger())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)